import React, { FunctionComponent, useMemo } from 'react'
import { PopoverState } from 'react-tiny-popover'
import styles from './CustomArrowContainer.module.sass'
import clsx from 'clsx'
import { calculateMaxHeight } from '../ShadowContainer/ShadowContainer'

interface Props {
    state: PopoverState
    className?: string,
    size?: number,
    color?: string,
}

const CustomArrowContainer: FunctionComponent<Props> = ({state, ...props}) => {
    const size = props.size || 16
    const half = size / 2

    const isVertical = state.position === 'top' || state.position === 'bottom'
    const isTop = state.position === 'top'
    const isLeft = state.position === 'left'

    const leftShift = Math.abs(state.childRect.left - state.popoverRect.left) + state.childRect.width / 2
    const topShift = Math.abs(state.childRect.top - state.popoverRect.top) + state.childRect.height / 2

    const line = Math.sqrt(2) * size - 2
    const halfLine = line / 2

    const maxHeight = useMemo(() => calculateMaxHeight(state.childRect), [state.childRect])

    return <div
        className={clsx(props.className, styles.arrowContainer)}
        style={{ padding: size }}
    >
        <div
            className={styles.arrow}
            style={{
                top: isVertical ?
                    (isTop ? state.popoverRect.height - size - half - 1: half) :
                    topShift - half,
                left: isVertical ?
                    leftShift - half:
                    (isLeft ? state.popoverRect.width - size - half - 1: half),
                width: size,
                height: size,
                background: props.color || 'white',
            }}
        />
        <div className={styles.container} style={{maxHeight}}>
            {props.children}
        </div>
        <div
            className={styles.containerShadow}
            style={{
                top: size,
                left: size,
                right: size,
                bottom: size,
            }}
        />
        <div
            style={{
                top: isVertical ?
                    (isTop ? state.popoverRect.height - size - 1: size) :
                    topShift,
                left: isVertical ?
                    leftShift - halfLine + 1:
                    (isLeft ? state.popoverRect.width - size - halfLine - 1: half - 2),
                height: 2,
                borderRadius: 2,
                transform: !isVertical? 'rotate(90deg)': undefined,
                width: line,
                background: 'white',
                content: ' ',
                display: 'block',
                position: 'absolute',
            }}
        />
    </div>
}

export default CustomArrowContainer